import { render, staticRenderFns } from "./ReportProblem.vue?vue&type=template&id=9caf599e"
import script from "./ReportProblem.vue?vue&type=script&lang=js"
export * from "./ReportProblem.vue?vue&type=script&lang=js"
import style0 from "./ReportProblem.vue?vue&type=style&index=0&id=9caf599e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports